module.exports = __webpack_public_path__ + "static/media/llanta-desgaste-desparejo-green.ad328adb.svg";